/**
 * @GENERATED from Figma node 3608:51001
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const BoxDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#0071F7"
      fillRule="evenodd"
      d="M4.5 2h15A2.5 2.5 0 0 1 22 4.5v15a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 19.5v-15A2.5 2.5 0 0 1 4.5 2"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.394 10.258a2.93 2.93 0 0 0-2.576 1.515c-.492-.91-1.477-1.515-2.613-1.515-.682 0-1.288.227-1.78.568V8.402a.583.583 0 0 0-.569-.569c-.34 0-.606.266-.606.569v4.772a2.9 2.9 0 0 0 2.917 2.841 2.98 2.98 0 0 0 2.613-1.553c.493.91 1.478 1.553 2.576 1.553 1.629 0 2.955-1.288 2.955-2.917.037-1.553-1.288-2.84-2.917-2.84m6.894 4.848c.19.265.151.606-.076.796-.265.189-.644.151-.833-.076l-1.326-1.705-1.288 1.667c-.19.265-.568.265-.833.076-.265-.19-.303-.53-.114-.796l1.515-1.97-1.515-1.97c-.19-.264-.114-.643.114-.832.265-.19.644-.114.833.113l1.288 1.705 1.326-1.63c.19-.264.53-.302.833-.113.265.19.265.568.076.834l-1.477 1.931zM7.167 14.88c-.985 0-1.78-.758-1.78-1.743 0-.947.795-1.742 1.78-1.742s1.78.795 1.78 1.742c0 .985-.795 1.743-1.78 1.743m5.227 0c-.985 0-1.78-.758-1.78-1.743 0-.947.795-1.742 1.78-1.742s1.78.795 1.78 1.742a1.795 1.795 0 0 1-1.78 1.743"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(BoxDark);
export { ForwardRef as BoxDark };
